// extracted by mini-css-extract-plugin
module.exports = {"inputText":"inputText_inputText__29AJA","inputMessage":"inputText_inputMessage__10QKY"};